import Layout from '@/components/feature/Layout';

const calendar = [
  { zone: 'Zona 1 - Barrio 12 de Octubre', dates: '1-5 de cada mes', day: 'Lunes a Viernes' },
  { zone: 'Zona 2 - Barrio San Martín', dates: '6-10 de cada mes', day: 'Lunes a Viernes' },
  { zone: 'Zona 3 - Alto San Jacinto', dates: '11-15 de cada mes', day: 'Lunes a Viernes' },
  { zone: 'Zona 4 - Los Pinos', dates: '16-20 de cada mes', day: 'Lunes a Viernes' },
  { zone: 'Zona 5 - Lomas de San Jacinto', dates: '21-25 de cada mes', day: 'Lunes a Viernes' },
];

export default function LecturacionPage() {
  return (
    <Layout>
      <div className="bg-primary-900 py-16 md:py-24">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            Servicio
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Lecturación de Medidores
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Conoce el calendario de lectura de medidores por zona y cómo reportar lecturas.
          </p>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-4xl mx-auto">
          {/* Calendar */}
          <div className="mb-10">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6">
              Calendario de Lectura por Zona
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="text-left py-3 px-4 font-semibold text-foreground-700">Zona</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-700">Fechas</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-700">Días</th>
                  </tr>
                </thead>
                <tbody>
                  {calendar.map((item, i) => (
                    <tr key={i} className="border-b border-background-200/50 hover:bg-background-100 transition-colors">
                      <td className="py-3 px-4 text-foreground-900">{item.zone}</td>
                      <td className="py-3 px-4 text-foreground-600">{item.dates}</td>
                      <td className="py-3 px-4 text-foreground-600">{item.day}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Info cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-3">
                <i className="ri-calendar-check-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-1">Lectura Mensual</h3>
              <p className="text-sm text-foreground-600">Los lectores visitan cada zona según el calendario establecido mensualmente.</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center mb-3">
                <i className="ri-file-list-3-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-1">Recibo de Agua</h3>
              <p className="text-sm text-foreground-600">Recibirás tu recibo con la lectura actual y el monto a pagar dentro de los 5 días hábiles.</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center mb-3">
                <i className="ri-camera-line text-secondary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-1">Reportar Lectura</h3>
              <p className="text-sm text-foreground-600">Puedes enviar foto de tu medidor por WhatsApp al <strong>+591 73455233</strong>.</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}